import React from 'react';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import mediator, { ACTIONS } from 'mediator';
import features from '../lib/common/features';

const BoxMinimumKey = React.createClass({
  propTypes: {
    data: PropTypes.array,
    isAvailable: PropTypes.bool.isRequired // eslint-disable-line react/no-unused-prop-types
  },

  getInitialState: function() {
    return {
      selectedLimit: [],
      limits: this.props.data,
      currentPriceTypes: []
    };
  },

  componentWillMount: function() {
    mediator.subscribe(
      ACTIONS.CURRENT_PRICE_ZONES_SELECTED,
      this.setSelectedPriceTypes
    );
  },

  componentWillUnmount: function() {
    mediator.unsubscribe(
      ACTIONS.CURRENT_PRICE_ZONES_SELECTED,
      this.setSelectedPriceTypes
    );
  },

  componentDidUpdate: function(prevProps, prevState) {
    let selectedLimit = this.state.selectedLimit;
    let selectedPrices = this.state.currentPriceTypes;
    let selected = [];

    if (selectedLimit.length && selectedPrices.length) {
      selected = selectedLimit.filter(x => selectedPrices.includes(x));
    } else {
      selected = [...selectedLimit, ...selectedPrices];
    }

    if (prevState.selectedLimit !== this.state.selectedLimit) {
      if (selected.length) {
        mediator.publish(ACTIONS.PRICE_FILTER_SELECTED, {
          selected: selected
        });
      } else {
        mediator.publish(ACTIONS.PRICE_FILTER_SELECTED, {
          selected: selected
        });
      }
    }
  },

  setSelectedPriceTypes: function(priceTypes) {
    this.setState({
      currentPriceTypes: priceTypes.selected.map(x => x)
    });
  },

  handleClick: function(val) {
    if (val && val !== this.state.selectedLimit) {
      this.setState({
        selectedLimit: val.zone_ids
      });

      if (features.isEnabled('podSeats')) {
        mediator.publish(ACTIONS.CURRENT_BOX_MINIMUM_SELECTED, {
          selectedZones: val.zone_ids
        });
      }
    } else if (!val && val !== this.state.selectedLimit) {
      this.setState({
        selectedLimit: []
      });

      if (features.isEnabled('podSeats')) {
        mediator.publish(ACTIONS.CURRENT_BOX_MINIMUM_SELECTED, {
          selectedZones: []
        });
      }
    }
  },

  render: function() {
    const { limits, selectedLimit } = this.state;
    const selected = find(limits, i => {
      return i.zone_ids === selectedLimit;
    });

    return limits ? (
      <div className="box-limit-selector">
        <div
          className="box-limit-selector--item"
          onClick={() => this.handleClick()}
        >
          <span>All Boxes</span>
        </div>
        {limits.map(item => {
          return (
            <div
              key={item.min_seats}
              onClick={() => this.handleClick(item)}
              className={`box-limit-selector--item ${selectedLimit &&
              selected !== undefined &&
              selected.min_seats === item.min_seats
                ? 'selected'
                : ''}`}
            >
              <span
                className="box-limit-item"
                style={{ color: `${item.color}` }}
              />
              <span>Minimum {item.min_seats} seats</span>
            </div>
          );
        })}
      </div>
    ) : null;
  }
});

export default BoxMinimumKey;



// WEBPACK FOOTER //
// ./src/javascripts/app/components/BoxMinimumKey.js